import React from 'react';
//import * as Icons from "react-icons/fa";
import '../../components/styles.css';

export default function Services() {
    return (
      <div className='container-content-services'>
          <div className='content-box-1' >
            <center>
                <h2>Digital Marketing Campaign Services We Provide For Our Partners</h2>
              </center>
          </div>
      </div>
    )
  };
